import React from 'react';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';


export const Video = ({ image, video, buttonSubtitle, buttonTitle, link }) => (
	<Col className="video-column" md={5} sm={12} xs={12}>
		<div className="clearfix">
			<div className="video-box">
				<div className="image-box"
				     style={{ backgroundImage: `url('${image}')` }}
				/>
			</div>

			<div className="more-box theme-btn">
				<Link to={link}>
					<div className="sub">{buttonSubtitle}</div>
					<div className="more clearfix"><span className="txt">{buttonTitle}</span> <span
						className="icon flaticon-arrows" /></div>
				</Link>
			</div>
		</div>
	</Col>
);



// WEBPACK FOOTER //
// ./src/components/ui/Video/Video.js